class DiscountForm {
  DOM = {
    cancelDiscountBtn: '#cancel-discount-button',
    makeDiscountBtn: '#make-discount-btn',
    selectBox: '#my-vehicles-selection',
    priceInput: '#discount-price-input',
    submitBtn: '#send-discount-button',
    vehicleSelect: '#vehicles-select',
    percentsContainer: '#percents',
    priceContainer: '#price',
    modal: '#discount_modal',
    discardBtn: '#discard',
    makeDiscountBtns: '.make-discount-btn'
  }

  constructor() {
    this.makeDiscountBtns = $(this.DOM.makeDiscountBtns);
    this.makeDiscountBtn = $(this.DOM.makeDiscountBtn);
    this.priceInput = $(this.DOM.priceInput);
    this.priceContainer = $(this.DOM.priceContainer);
    this.submitBtn = $(this.DOM.submitBtn);
    this.modal = $(this.DOM.modal);
    this.discardBtn = $(this.DOM.discardBtn);
    this.percentsContainer = $(this.DOM.percentsContainer);
    this.selectBox = $(this.DOM.selectBox);
    this.vehicleSelect = $(this.DOM.vehicleSelect);
    this.cancelDiscountBtn = $(this.DOM.cancelDiscountBtn);
    this.state = {
      form: { listing: { discount_price: '' } },
      maxPrice: '',
      minPrice: '',
      action: ''
    };
  }

  init() {
    this.setListeners();
  }

  setListeners() {
    this.makeDiscountBtns.on('click', this.onDiscountBtnsClick.bind(this));
    this.submitBtn.on('click', this.onSubmitBtnClick.bind(this));
    this.priceInput.on('input', this.onPriceInputChange.bind(this));
    this.makeDiscountBtn.on('click', this.onDiscountBtnClick.bind(this));
    this.vehicleSelect.on('change', this.onVehicleSelect.bind(this));
    this.cancelDiscountBtn.on('click', this.onCancel.bind(this));
    this.discardBtn.on('click', this.onDiscardDiscount.bind(this));
  }

  onPriceInputChange(e) {
    const { name, value } = e.target;
    this.state.form.listing[name] = parseInt(value.split(',').join(''), 0);
    this.validatePriceInput();
  }

  onDiscountBtnsClick(e) {
    this.resetForm();
    this.state.minPrice = parseInt(this.priceInput.attr('data-min-price'), 0);
    this.state.action = $(e.currentTarget).attr('href');
    this.state.maxPrice = parseInt($(e.currentTarget).attr('data-max-price'), 0);
    this.state.form.listing.discount_price = parseInt($(e.currentTarget).attr('data-current-discount'), 0);
    this.priceContainer.html(this.state.maxPrice);
    this.showCurrentDiscount();
    this.showDiscardBtn();
  }

  onDiscountBtnClick() {
    this.resetForm();
    this.state.minPrice = parseInt(this.priceInput.attr('data-min-price'), 0);
    this.selectBox.removeClass('hide');
  }

  onCancel(e) {
    e.preventDefault();
    this.resetForm();
  }

  showDiscardBtn() {
    if (this.state.form.listing.discount_price) {
      this.discardBtn.show();
    } else {
      this.discardBtn.hide();
    }
  }

  onDiscardDiscount(e) {
    e.preventDefault();
    this.state.form.listing.discount_price = '';
    if (this.validateSelectBox()) {
      this.submitForm()
        .then(() => {
          window.vFlashMessage('Discount discarded successfully', 'alert-warning');
          this.resetForm();
          location.reload();
        })
        .catch(() => {
          window.vFlashMessage('Something went wrong', 'alert-danger');
          this.resetForm();
        });
    }
  }

  onSubmitBtnClick(e) {
    e.preventDefault();
    if (this.validateForm()) {
      this.submitForm()
        .then(() => {
          window.vFlashMessage('Discount applied successfully', 'alert-success');
          location.reload();
        })
        .catch(() => {
          window.vFlashMessage('Something went wrong', 'alert-danger');
          this.resetForm();
        });
    }
  }

  onVehicleSelect(e) {
    const { action, price, discountPrice } = JSON.parse(e.target.value);
    this.state.action = action;
    this.priceContainer.html(price);
    this.state.maxPrice = price;
    this.state.form.listing.discount_price = discountPrice;
    this.showCurrentDiscount();
    this.validateSelectBox();
    this.showDiscardBtn();
  }

  submitForm() {
    return new window.Promise((resolve, reject) => {
      $.ajax({
        url: this.state.action,
        type: 'put',
        contentType: 'application/json',
        dataType: 'json',
        data: JSON.stringify(this.state.form)
      })
        .done(() => resolve())
        .fail(() => reject());
    });
  }

  resetForm() {
    this.clearErrors([this.priceInput, this.vehicleSelect]);
    this.vehicleSelect.val('').trigger('chosen:updated');
    this.clearState(this.state);
    this.priceInput.val('');
    this.percentsContainer.html('0');
    this.priceContainer.html('');
    this.modal.modal('hide');
    this.selectBox.addClass('hide');
    this.discardBtn.hide();
  }

  validateForm() {
    if (this.validateSelectBox() && this.validatePriceInput()) {
      this.clearErrors([this.priceInput, this.vehicleSelect]);
      return true;
    }
    return false;
  }

  validateSelectBox() {
    if (this.state.action === '') {
      this.triggerErrors(this.vehicleSelect, window.I18n.t('cant_be_blank'));
      return false;
    }
    this.clearErrors([this.vehicleSelect]);
    return true;
  }

  validatePriceInput() {
    const { maxPrice, minPrice, form: { listing: { discount_price: price } } } = this.state;

    if (isNaN(price) || price === '') {
      this.triggerErrors(this.priceInput, window.I18n.t('cant_be_blank'));
      return false;
    } else if (price < minPrice) {
      this.triggerErrors(this.priceInput, window.I18n.t('greater', { price: minPrice }));
      return false;
    } else if (maxPrice && price >= maxPrice) {
      this.triggerErrors(this.priceInput, window.I18n.t('lower', { price: maxPrice }));
      return false;
    }
    this.calcPercents();
    this.clearErrors([this.priceInput]);
    return true;
  }

  triggerErrors(input, error) {
    const errorSpan = `<span class='customErrorText'>${error}</span>`;
    input.nextAll('.customErrorText').remove();
    input.after(errorSpan);
    input.parent().addClass('custom_field_with_errors field_with_errors');
  }

  clearErrors(inputs) {
    for (let i = 0; i < inputs.length; i++) {
      inputs[i].nextAll('.customErrorText').remove();
      inputs[i].parent().removeClass('custom_field_with_errors field_with_errors');
    }
  }

  calcPercents() {
    const perc = Math.ceil(100 - (this.state.form.listing.discount_price * 100 / this.state.maxPrice));
    const result = perc === 100 ? 99 : perc;
    this.percentsContainer.html(result || 0);
    return perc;
  }

  showCurrentDiscount() {
    if (this.state.form.listing.discount_price) {
      this.priceInput.val(this.state.form.listing.discount_price);
      this.calcPercents();
    } else {
      this.state.form.listing.discount_price = '';
      this.priceInput.val('');
      this.percentsContainer.html('0');
    }
  }

  clearState(state) {
    for (const key in state) {
      if (state.hasOwnProperty(key)) {
        typeof state[key] === 'object' ? this.clearState(state[key]) : state[key] = '';
      }
    }
  }
}

export { DiscountForm };



// WEBPACK FOOTER //
// ./app/webpacker/src/js/discount_form.js